/**
 *  @class
 *  @function FacetsToggle
 */
class FacetToggle extends HTMLElement {

  constructor() {
    super();
    this.init();
  }
  init() {
    this.drawer = document.getElementById('Facet-Drawer');
    this.container = this.closest('.facets--bar-sticky');

    // Add functionality to buttons
    this.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
    });
    if (this.container) {
      this.enableSticky();
    }

  }
  enableSticky() {
    let rootMargin = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) + 1;
    this.observer = new IntersectionObserver(
      ([e]) => {
        e.target.classList.toggle('is-pinned', e.intersectionRatio <= 1 && e.intersectionRatio > 0);
      },
      {
        threshold: [1],
        rootMargin: `-${rootMargin}px 0px 0px 0px`
      }
    );

    this.observer.observe(this.container);
  }

}
customElements.define('facet-toggle', FacetToggle);

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.id === 'compare_toggle') {
        return;
      }
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        // FacetFiltersForm.renderSortList(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    // FacetFiltersForm.renderSortList(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  //=========================
  static renderSortList(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');        
    const currentSortList = document.querySelector('.js-opk-custom-select-list-sort');
    if (!currentSortList) return; 
    const newSortList = parsedHTML.querySelector('.js-opk-custom-select-list-sort');                
    // console.log('newSortList', newSortList);
    currentSortList.innerHTML = newSortList.innerHTML;         
  }
  //=========================  

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');    

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row:not(:has(.js-opk-filter-list)), #FacetFiltersFormMobile collapsible-row:not(:has(.js-opk-filter-list))');
    
    const currentFilterCollapsibles = document.querySelectorAll('collapsible-row');   

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    //================================    
    if (!currentFilterCollapsibles.length) return;         
    
    currentFilterCollapsibles.forEach((currentFilterCollapsible, index) => {
      const currentCollapsibleList = currentFilterCollapsible.querySelector('.js-opk-filter-list');
      if (!currentCollapsibleList) return;
      const currentCollapsibleIndex = currentFilterCollapsible.dataset.index;      
      const newCollapsibleRows = parsedHTML.querySelectorAll(`collapsible-row[data-index="${currentCollapsibleIndex}"] .js-opk-filter-list`);
      // console.log('currentCollapsibleList', currentCollapsibleList);
      // console.log('newCollapsibleRows', newCollapsibleRows[0]);
      
      if (newCollapsibleRows.length) {
        newCollapsibleRows.forEach((newCollapsibleRow) => {
          currentCollapsibleList.innerHTML = newCollapsibleRow.innerHTML;
        })
      }
    });    
    //================================

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target?.querySelector('.facets__selected');
    const sourceElement = source?.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function Facetremove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.compareToggle = this.querySelector('#compare_toggle');
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
    return false;
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */

const currencySymbol = '€';

const normalizeNumber = (value) => {
  if (value === null || value === undefined) return 0;
  return Math.round(parseFloat(String(value).replace(',', '.')) || 0);
};

const formatPrice = (value) => {
  return currencySymbol + normalizeNumber(value).toLocaleString('nl-NL');
};

const unformatPrice = (value) => {
  return normalizeNumber(value.replace(/[^\d.,]/g, ''));
};

class PriceSlider extends HTMLElement {
  connectedCallback() {
    const slider = this.querySelector('.price_slider');
    const amounts = this.querySelector('.price_slider_amount');

    const inputMin = amounts.querySelector('.field__input_min');
    const inputMax = amounts.querySelector('.field__input_max');

    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');

    const event = new CustomEvent('input', { bubbles: true });

    const minStart = normalizeNumber(slider.dataset.minValue || 0);
    const maxStart = normalizeNumber(slider.dataset.maxValue || slider.dataset.max);
    const maxRange = normalizeNumber(slider.dataset.max);

    // destroy if exists
    if (slider.noUiSlider) slider.noUiSlider.destroy();

    noUiSlider.create(slider, {
      start: [minStart, maxStart],
      connect: true,
      step: 1,
      direction: document.dir,
      range: {
        min: 0,
        max: maxRange,
      },
    });

    // === slider → inputs ===
    slider.noUiSlider.on('update', (values) => {
      const min = normalizeNumber(values[0]);
      const max = normalizeNumber(values[1]);

      inputMin.dataset.raw = min;
      inputMax.dataset.raw = max;

      inputMin.value = formatPrice(min);
      inputMax.value = formatPrice(max);
    });

    slider.noUiSlider.on('change', () => {
      form?.querySelector('form')?.dispatchEvent(event);
    });

    // === inputs UX ===
    [inputMin, inputMax].forEach((input) => {
      input.addEventListener('focus', () => {
        input.value = input.dataset.raw || unformatPrice(input.value);
      });

      input.addEventListener('input', () => {
        input.value = unformatPrice(input.value);
      });

      input.addEventListener('blur', () => {
        const raw = unformatPrice(input.value);
        input.dataset.raw = raw;
        input.value = formatPrice(raw);
      });
    });

    // === BEFORE SUBMIT (CRITICAL) ===
    form?.querySelector('form')?.addEventListener('submit', () => {
      [inputMin, inputMax].forEach((input) => {
        input.value = input.dataset.raw || unformatPrice(input.value);
      });
    });
  }
}

customElements.define('price-slider', PriceSlider);